/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doc': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.25 17.57',
    data: '<g data-name="图层 2"><g data-name="图层 1"><path pid="0" d="M15.25.5v10.08a.5.5 0 11-1 0V1H1v15.57h6.91a.5.5 0 010 1H.5a.5.5 0 01-.5-.5V.5A.5.5 0 01.5 0h14.25a.5.5 0 01.5.5zm-4 3.26H3.72a.5.5 0 000 1h7.53a.5.5 0 000-1zm0 3H3.72a.5.5 0 000 1h7.53a.5.5 0 000-1zm-7.53 3a.5.5 0 100 1h3.1a.5.5 0 100-1z" _fill="#c4c4c4"/><path pid="1" _fill="#74777a" d="M14.75 11.99H9.51v5.08l5.24-5.08z"/></g></g>'
  }
})
